import { Component, Input } from "@angular/core";
import { BlogService } from "../../shared/blog.service";

@Component({
    selector: "mlp-blog-tags",
    templateUrl: "./blog-tags.component.html",
    styleUrls: ["./blog-tags.component.scss"],
})
export class BlogTagsComponent {
    constructor(public blogService: BlogService) {}
    @Input() blog: any;
    @Input() maxCategories: number;

    findCategory(categoryId: number): string {
        let name = "";
        if (
            this.blogService.categories &&
            this.blogService.categories.length > 0
        ) {
            this.blogService.categories.forEach((category) => {
                if (category.id === categoryId) {
                    name = category.name;
                }
            });
        }

        return name;
    }

    findCategorySlug(categoryId: number): string {
        let name = "";
        if (
            this.blogService.categories &&
            this.blogService.categories.length > 0
        ) {
            this.blogService.categories.forEach((category) => {
                if (category.id === categoryId) {
                    name = category.slug;
                }
            });
        }

        return name;
    }
}
